import { Icon } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { memo, useMemo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { SearchSocialMediaItemProps as Props } from './types';
import { getSocialMediaLink, isSocialMediaLinkAvailable } from './utils';

export const SearchSocialMediaItem = memo(
  ({ className, item, link }: Props) => {
    const available = useMemo(
      () => isSocialMediaLinkAvailable(item, link),
      [item, link]
    );
    const href = useMemo(() => getSocialMediaLink(item, link), [item, link]);
    const linkColor = useMemo(
      () => (available ? 'grey.600' : 'grey.400'),
      [available]
    );

    return (
      <Styled.Wrapper
        className={classnames('SearchSocialMediaItem', className)}
        sx={SX.root(available)}
        disabled={!available}
        href={href}
        variant="text"
        size="xsmall"
      >
        <Icon
          size={18}
          name={item.icon}
          color={linkColor}
          sxx={SX.icon(available)}
        />
      </Styled.Wrapper>
    );
  }
);

SearchSocialMediaItem.displayName = 'SearchSocialMediaItem';
